export default [
  {field: "index", key: "index", label: "ลำดับ", sortable: true},
  {field: "shop_name", key: "shop_name", label: "ชื่อร้านค้า", sortable: true},
  {
    field: "receipt_no",
    key: "receipt_no",
    label: "เลขที่ใบเสร็จ",
    sortable: true,
    dataFormat: (value) => {
      return value ? `${value}` : "รวม";
    },
  },
  {
    field: "barcode",
    key: "barcode",
    label: "หมายเลขติดตามพัสดุ",
    sortable: true,
  },
  {
    field: "date_time_shipping",
    key: "date_time_shipping",
    label: "วันที่จัดส่ง",
    sortable: true,
  },
  {
    field: "date_time_complete",
    key: "date_time_complete",
    label: "วันที่ส่งสำเร็จ",
    sortable: true,
  },
  {field: "status", key: "status", label: "สถานะ", sortable: true},
  {field: "to_name", key: "to_name", label: "ชื่อผู้รับ", sortable: true},
  {
    field: "sender",
    key: "sender",
    label: "ชื่อผู้ส่ง",
    sortable: true,
    dataFormat: (value) => {
      return value ? `${value.name}` : "";
    },
  },
  {
    field: "date_time_transfer",
    key: "date_time_transfer",
    label: "วันที่โอนคืน",
    sortable: true,
  },
  {
    field: "cod_amount",
    key: "cod_amount",
    label: "ยอดเก็บเงินปลายทาง",
    sortable: true,
  },
  {
    field: "service_fee",
    key: "service_fee",
    label: "ค่าธรรมเนียม",
    sortable: true,
  },
  {
    field: "r_cod_amount",
    key: "r_cod_amount",
    label: "ยอดโอนคืน",
    sortable: true,
  },
  {field: "commission", key: "commission", label: "commission", sortable: true},
  {
    field: "status_transfer",
    key: "status_transfer",
    label: "สถานะโอนคืน",
    sortable: true,
  },
];
